<template>
    <div>
        <EmergencyPreparednessSection />
        <EvacuationSection class="mt-2" />
    </div>
</template>

<script src="./EmergencyPreparedness.ts"></script>
